/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { Condition } from './Condition';
import {
  ConditionFromJSON,
  ConditionFromJSONTyped,
  ConditionToJSON,
} from './Condition';
import type { RuleSettings } from './RuleSettings';
import {
  RuleSettingsFromJSON,
  RuleSettingsFromJSONTyped,
  RuleSettingsToJSON,
} from './RuleSettings';

/**
 *
 * @export
 * @interface Rule
 */
export interface Rule {
  /**
   *
   * @type {number}
   * @memberof Rule
   */
  companyId: number;
  /**
   * Rule conditions
   * @type {Array<Condition>}
   * @memberof Rule
   */
  conditions?: Array<Condition>;
  /**
   *
   * @type {number}
   * @memberof Rule
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof Rule
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Rule
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Rule
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {Array<any>}
   * @memberof Rule
   */
  flowIds?: Array<any>;
  /**
   *
   * @type {string}
   * @memberof Rule
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Rule
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof Rule
   */
  parentId?: string;
  /**
   *
   * @type {string}
   * @memberof Rule
   */
  parentKey?: string;
  /**
   *
   * @type {string}
   * @memberof Rule
   */
  ruleId?: string;
  /**
   * Rule settings in dict
   * @type {RuleSettings}
   * @memberof Rule
   */
  settings?: RuleSettings;
  /**
   * Rule Type
   * @type {string}
   * @memberof Rule
   */
  type: RuleTypeEnum;
}

/**
 * @export
 */
export const RuleTypeEnum = {
  Call: 'call',
  Sms: 'sms',
} as const;
export type RuleTypeEnum = (typeof RuleTypeEnum)[keyof typeof RuleTypeEnum];

/**
 * Check if a given object implements the Rule interface.
 */
export function instanceOfRule(value: object): value is Rule {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function RuleFromJSON(json: any): Rule {
  return RuleFromJSONTyped(json, false);
}

export function RuleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Rule {
  if (json == null) {
    return json;
  }
  return {
    companyId: json['company_id'],
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ConditionFromJSON),
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    flowIds: json['flow_ids'] == null ? undefined : json['flow_ids'],
    id: json['id'],
    key: json['key'],
    parentId: json['parent_id'] == null ? undefined : json['parent_id'],
    parentKey: json['parent_key'] == null ? undefined : json['parent_key'],
    ruleId: json['rule_id'] == null ? undefined : json['rule_id'],
    settings:
      json['settings'] == null
        ? undefined
        : RuleSettingsFromJSON(json['settings']),
    type: json['type'],
  };
}

export function RuleToJSON(value?: Rule | null): any {
  if (value == null) {
    return value;
  }
  return {
    company_id: value['companyId'],
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ConditionToJSON),
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    flow_ids: value['flowIds'],
    id: value['id'],
    key: value['key'],
    parent_id: value['parentId'],
    parent_key: value['parentKey'],
    rule_id: value['ruleId'],
    settings: RuleSettingsToJSON(value['settings']),
    type: value['type'],
  };
}
